export default __webpack_public_path__ + "static/nfpa_b.9c9eb86d5169c64256bd4d9170ad6c1a.png";